module.exports = __webpack_public_path__ + "img/40.5ef89d29.jpg";